export enum questionCategory {
    ALL = "see all",
    PROGRAM = "my enrollment",
    COUPONS = "my account",
    REWARDS = "my rewards"
}